export default __webpack_public_path__ + "static/media/couchbase.f546e13a.svg";